import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import ListIcon from '@mui/icons-material/List';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import { styled } from '@mui/material/styles';

import BorderColorSharpIcon from '@mui/icons-material/BorderColorSharp';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DeleteIcon from '@mui/icons-material/Delete';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from '@mui/icons-material/Visibility';
import InspectionBreadcrumbs from './../InspectionBreadcrumbs';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { alpha } from '@mui/material/styles';

import { visuallyHidden } from '@mui/utils';
import {
    InspectionContents,
    CautionButton,
    GrayButton,
    NomalButton
} from '../../css/CSS.js';
import InspectionDelConfirm from "./InspectionDelConfirm"
import { inspecReportList } from "./InspectionItemFrame"
import LoadingDialog from '../../Loading';
import useAuthAxios from "../../../useAuthAxios";
import PropTypes from 'prop-types';
import { toHalfWidthAlpha, toHalfWidthKana, toHalfWidthNumber } from '../InspectionValidations'
import InspectionCommonDialog from '../InspectionCommonDialog'

export default function ShorttermWarrantyListBody() {
    const headers = { "Authorization": "Bearer " + localStorage.getItem("Auth") };


    const TableFlame = styled(TableContainer)({
        borderRadius: "10px 10px 0 0",
    });

    const CLTableCell = styled(TableCell)({
        padding: "5px",
    });

    const Works = styled(Button)({
        color: "#000000",
    });

    const Header = styled(TableRow)({
        backgroundColor: "#289bdf",
    });
    const Text = styled(Typography)({
        color: "#FFFFFF",
        transform: "scale(0.9)",
    });

    let deleteAuth = false;

    if (localStorage.getItem("inspectionRecordDelete") === "1") {
        deleteAuth = true;
    }

    const pathName = useLocation().pathname;
    const termName = pathName.split("/").slice(-2)[0];
    let term;
    switch (termName) {
        case "shorttermWarranty":
            term = 0;
            break
        case "longtermWarranty":
            term = 1;
            break
        default:
    }
    const { control, handleSubmit, getValues, setValue, watch } = useForm({
        defaultValues: {
            kojiCD: "",
            customerCD: "",
            shitenCD: "",
            thokiYuryoFlg: "",
            customerNameKana: ""
        },
        mode: "onBlur",
        reValidateMode: "onBlur",
    });

    const navigate = useNavigate();

    const [deleteMode, setDeleteMode] = useState(false);
    const [processing_search, setProcessing_search] = useState(false);
    const [processing_searchReset, setProcessing_searchReset] = useState(false);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [list, setList] = useState({});
    const [kojiCD, setKojiCD] = useState('');
    const [rptShubetsu, setRptShubetsu] = useState('');
    const [rptShubetsuName, setRptShubetsuName] = useState('');
    const [rptSeq, setRrptSeq] = useState('');
    const [delDialog, setDelDialog] = useState(false);
    const [officeList, setOfficeList] = useState([]);
    const [shitenSelectList, setShitenSelectList] = useState([]);
    const authAxios = useAuthAxios();
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        const previousCondition = term === 0 ? sessionStorage.getItem('shortTermSearchCondition') : sessionStorage.getItem('longTermSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            const newCondition = {
                ...searchConditions,
                sort: {
                    order: isAsc ? 'desc' : 'asc',
                    orderBy: property,
                }
            }
            term === 0
                ? sessionStorage.setItem('shortTermSearchCondition', JSON.stringify(newCondition))
                : sessionStorage.setItem('longTermSearchCondition', JSON.stringify(newCondition));
        }
    };
    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        const finishKey = `${orderBy}FinishDate`;
        const aFinish = a[finishKey] ?? 0;
        const bFinish = b[finishKey] ?? 0;
        if (bFinish < aFinish) {
            return -1;
        }
        if (bFinish > aFinish) {
            return 1;
        }
        const aCustomerCD = a.customerCD ?? 0;
        const bCustomerCD = b.customerCD ?? 0;
        if (bCustomerCD < aCustomerCD) {
            return -1;
        }
        if (bCustomerCD > aCustomerCD) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }
    function stableSort(array, comparator) {
        const stabilizedThis = array?.map((el, index) => [el, index]);
        stabilizedThis?.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis?.map((el) => el[0]);
    }

    const handleChangePage = (event, newPage) => {
        const previousCondition = term === 0 ? sessionStorage.getItem('shortTermSearchCondition') : sessionStorage.getItem('longTermSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            const newCondition = {
                ...searchConditions,
                pagination: {
                    ...searchConditions.pagination,
                    page: newPage,
                }
            }
            term === 0
                ? sessionStorage.setItem('shortTermSearchCondition', JSON.stringify(newCondition))
                : sessionStorage.setItem('longTermSearchCondition', JSON.stringify(newCondition));
        }
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        const previousCondition = term === 0 ? sessionStorage.getItem('shortTermSearchCondition') : sessionStorage.getItem('longTermSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            const newCondition = {
                ...searchConditions,
                pagination: {
                    page: 0,
                    pageSize: newPageSize
                }
            }
            term === 0
                ? sessionStorage.setItem('shortTermSearchCondition', JSON.stringify(newCondition))
                : sessionStorage.setItem('longTermSearchCondition', JSON.stringify(newCondition));
        }
        setRowsPerPage(newPageSize);
        setPage(0);
    };

    const [expanded, setExpanded] = useState(false);

    const typeItems = {
        shortTermTypes: [
            {
                id: 'sts3mt',
                label: '3か月点検'
            },
            {
                id: 'sts6mt',
                label: '6か月点検'
            },
            {
                id: 'sts12mt',
                label: '12か月点検'
            },
            {
                id: 'sts24mt',
                label: '24か月点検'
            }],
        longTermTypes: [
            {
                id: 'sts4yt',
                label: '4年点検'
            },
            {
                id: 'sts7yt',
                label: '7年点検'
            },
            {
                id: 'sts10yt',
                label: '10年点検'
            }]
    }
    const statusItems = [
        {
            status: 'N',
            label: '未作成'
        },
        {
            status: 'P',
            label: '作成中'
        },
        {
            status: 'C',
            label: '作成済み'
        },
        {
            status: 'F',
            label: '作成済み(確定)'
        }
    ];

    let headCells = [];
    switch (term) {
        case 0:
            headCells = [
                {
                    id: 'customerNo',
                    label: 'お客様No',
                    align: 'left',
                    width: '11%',
                },
                {
                    id: 'kojiCD',
                    label: '工事コード',
                    align: 'left',
                    width: '11%',
                },
                {
                    id: 'shitenName',
                    label: '支店名',
                    align: 'left',
                    width: '11%',
                },

                {
                    id: 'kojiName',
                    label: '邸名',
                    align: 'left',
                    width: '22%',
                },
                {
                    id: 'tenken3m',
                    label: '点検3か月',
                    align: 'left',
                    width: '11%',
                },
                {
                    id: 'tenken6m',
                    label: '点検6か月',
                    align: 'left',
                    width: '11%',
                },
                {
                    id: 'tenken12m',
                    label: '点検12か月',
                    align: 'left',
                    width: '11%',
                },
                {
                    id: 'tenken24m',
                    label: '点検24か月',
                    align: 'left',
                    width: '11%',
                },
            ];
            break
        case 1:
            //ToDo長期保証
            headCells = [
                {
                    id: 'customerNo',
                    label: 'お客様No',
                    align: 'left',
                    width: '11%',
                },
                {
                    id: 'kojiCD',
                    label: '工事コード',
                    align: 'left',
                    width: '11%',
                },
                {
                    id: 'shitenName',
                    label: '支店名',
                    align: 'left',
                    width: '11%',
                },

                {
                    id: 'kojiName',
                    label: '邸名',
                    align: 'left',
                    width: '22%',
                },
                {
                    id: 'tenken4y',
                    label: '点検4年',
                    align: 'left',
                    width: '11%',
                },
                {
                    id: 'tenken7y',
                    label: '点検7年',
                    align: 'left',
                    width: '11%',
                },
                {
                    id: 'tenken10y',
                    label: '点検10年',
                    align: 'left',
                    width: '11%',
                },
            ];
            break
        default:
    }

    function EnhancedTableHead(props) {
        const { order, orderBy, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <Header sx={{ backgroundColor: props.mode === true ? "#C0C0C0" : "#289bdf" }}>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            width={headCell.width}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                <Text sx={{ color: props.mode === true ? "#000000" : "#FFFFFF" }}>{headCell.label}</Text>
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </Header>
            </TableHead >
        );
    }

    EnhancedTableHead.propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number,
    };

    const onSubmit_ChangeListMode = () => {
        setDeleteMode(false);
    }

    const onSubmit_ChangeDeleteMode = () => {
        setDeleteMode(true);
    }

    const validationRules = {
        kojiCD: {
            maxLength: {
                value: 5,
            },
            pattern: {
                value: /^[0-9a-zA-Z]+$/,
                message: "半角英数字のみ入力可能です",
            },
        },
        customerCD: {
            maxLength: {
                value: 7,
            },
            pattern: {
                value: /^[0-9a-zA-Z]+$/,
                message: "半角英数字のみ入力可能です",
            },
        },
        customerNameKana: {
            pattern: {
                value: /^[\uFF65-\uFF9F\sA-Za-z0-9]*$/,
                message: "半角英数カナで入力してください",
            },
        }
    }

    const [processing, setProcessing] = useState(false);
    const disable_processing = useRef(false);

    const deleteChecked = (kojiCD, rptShubetsu, rptSeq) => {
        setKojiCD(kojiCD);
        setRptShubetsu(rptShubetsu);
        setRrptSeq(rptSeq);
        switch (rptShubetsu) {
            case "3MT":
                setRptShubetsuName("3か月点検");
                break;
            case "6MT":
                setRptShubetsuName("6か月点検");
                break;
            case "12MT":
                setRptShubetsuName("12か月点検");
                break;
            case "24MT":
                setRptShubetsuName("24か月点検");
                break;
            //ToDo長期保証
            case "4YT":
                setRptShubetsuName("4年点検");
                break;
            case "7YT":
                setRptShubetsuName("7年点検");
                break;
            case "10YT":
                setRptShubetsuName("10年点検");
                break;
            default:

        }
        setDelDialog(true);
    }

    React.useEffect(() => {
        //初期表示時
        if (shitenSelectList.length === 0) return;
        //支店リストセット完了後
        const previousCondition = term === 0 ? sessionStorage.getItem('shortTermSearchCondition') : sessionStorage.getItem('longTermSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            setValue("customerCD", searchConditions.customerCD);
            setValue("kojiCD", searchConditions.kojiCD);
            setValue("shitenCD", searchConditions.shitenCD);
            setValue("thokiYuryoFlg", searchConditions.thokiYuryoFlg);
            setValue("customerNameKana", searchConditions.customerNameKana);
            if (term === 0) {
                setValue("sts3mt", searchConditions.type3MT);
                setValue("sts6mt", searchConditions.type6MT);
                setValue("sts12mt", searchConditions.type12MT);
                setValue("sts24mt", searchConditions.type24MT);
                if (searchConditions.customerCD !== "" ||
                    searchConditions.kojiCD !== "" ||
                    (searchConditions.type3MT ?? []).length !== 0 ||
                    (searchConditions.type6MT ?? []).length !== 0 ||
                    (searchConditions.type12MT ?? []).length !== 0 ||
                    (searchConditions.type24MT ?? []).length !== 0) {
                    setExpanded(true);
                }
            } else {
                setValue("sts4yt", searchConditions.type4YT);
                setValue("sts7yt", searchConditions.type7YT);
                setValue("sts10yt", searchConditions.type10YT);
                if (searchConditions.customerCD !== "" ||
                    searchConditions.kojiCD !== "" ||
                    (searchConditions.type4YT ?? []).length !== 0 ||
                    (searchConditions.type7YT ?? []).length !== 0 ||
                    (searchConditions.type10YT ?? []).length !== 0) {
                    setExpanded(true);
                }
            }
            setRowsPerPage(searchConditions.pagination.pageSize);
            setPage(searchConditions.pagination.page);
            setProcessing(true)
            setOrder(searchConditions.sort.order);
            setOrderBy(searchConditions.sort.orderBy);
            const apiUrl = createSearchUrl(getValues());
            authAxios
                .get(apiUrl)
                .then(response => {
                    if (response.status === 200) {
                        const listdata = JSON.parse((JSON.stringify(response.data)));
                        setList(listdata);
                        setProcessing(false);
                    }
                }).catch((response) => {
                    alert("一覧情報取得に失敗しました。", response.body);
                    switch (localStorage.getItem("loginType")) {
                        case "0":
                            navigate("/");
                            break
                        case "1":
                            navigate("/omsuser");
                            break
                        case "2":
                            navigate("/vender");
                            break
                        default:
                            navigate("/");
                    }
                    setProcessing(false)
                });
        } else {
            if (localStorage.getItem("UserShitenCD")) {
                const defaultShitenCD = localStorage.getItem("UserShitenCD");
                const target = shitenSelectList.find(item => item.shitenCD === defaultShitenCD);
                setValue("shitenCD", target ? target.shitenCD : "");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shitenSelectList]);

    React.useLayoutEffect(() => {
        setProcessing(true)
        authAxios
            .get('api/inspection/inspectionVendor/offices', { headers })
            .then(response => {
                if (response.status === 200) {
                    const listdata = JSON.parse((JSON.stringify(response.data)));
                    const selectList = [];
                    setOfficeList(listdata);
                    selectList.push({ shitenCD: "", shitenName: "未選択" })
                    listdata.shitenInfo.forEach((e) => selectList.push({ shitenCD: e.shitenCD, shitenName: e.shitenName }))
                    setShitenSelectList(selectList)
                    setProcessing(false);
                }
            }).catch((response) => {
                alert("支店情報取得に失敗しました。", response.body);
                setProcessing(false)
                navigate("/inspection");
            });
        setProcessing(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmit = (data, e) => {
        const action = e?.nativeEvent.submitter?.value;
        switch (action) {
            case 'search':
                onSubmit_Search(data);
                break;
            default:
                return null;
        }
    }
    const fieldLabels = {
        kojiCD: "工事コード",
        customerCD: "お客様No",
        customerNameKana: "邸名（半角カナ）",
    };

    const fieldToLabel = (field) => fieldLabels[field] ?? field;
    const [dialogState, setDialogState] = useState({ open: false });
    const onError = (errors) => {
        const firstErrorKey = Object.keys(errors)[0];
        const firstError = errors[firstErrorKey];

        const message = firstError?.message;
        const fieldLabel = fieldToLabel(firstErrorKey)
        setDialogState({
            open: true,
            title: "入力エラー",
            message: fieldLabel + "は" + message,
            confirmClick: () => { setDialogState(prev => ({ ...prev, open: false })); },
            cancelClick: () => { setDialogState(prev => ({ ...prev, open: false })); },
            confirmIcon: <></>,
            buttonType: "NomalButton",
            hideCancel: true,
        })
    };

    const onSubmit_Search = (data) => {
        setProcessing_search(true);
        const apiUrl = createSearchUrl(data);
        authAxios
            .get(apiUrl)
            .then((response) => {
                if (response.status === 200) {
                    const listdata = JSON.parse((JSON.stringify(response.data)));
                    setList(listdata);
                    setPage(0);
                    setOrder('asc');
                    setOrderBy('');
                    setProcessing_search(false);
                    if (term === 0) {
                        const shortTermSearchCondition = {
                            kojiCD: data.kojiCD,
                            customerCD: data.customerCD,
                            shitenCD: data.shitenCD,
                            thokiYuryoFlg: data.thokiYuryoFlg,
                            customerNameKana: data.customerNameKana,
                            type3MT: data.sts3mt,
                            type6MT: data.sts6mt,
                            type12MT: data.sts12mt,
                            type24MT: data.sts24mt,
                            pagination: {
                                page: 0,
                                pageSize: rowsPerPage
                            },
                            sort: {
                                order: 'asc',
                                orderBy: '',
                            }
                        }
                        sessionStorage.setItem('shortTermSearchCondition', JSON.stringify(shortTermSearchCondition));
                    } else {
                        const longTermSearchCondition = {
                            kojiCD: data.kojiCD,
                            customerCD: data.customerCD,
                            shitenCD: data.shitenCD,
                            thokiYuryoFlg: data.thokiYuryoFlg,
                            customerNameKana: data.customerNameKana,
                            type4YT: data.sts4yt,
                            type7YT: data.sts7yt,
                            type10YT: data.sts10yt,
                            pagination: {
                                page: 0,
                                pageSize: rowsPerPage
                            },
                            sort: {
                                order: 'asc',
                                orderBy: '',
                            }
                        }
                        sessionStorage.setItem('longTermSearchCondition', JSON.stringify(longTermSearchCondition));
                    }
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    alert("認証情報が正しくありません。");
                    switch (localStorage.getItem("loginType")) {
                        case "0":
                            navigate("/");
                            break
                        case "1":
                            navigate("/omsuser");
                            break
                        case "2":
                            navigate("/vender");
                            break
                        default:
                            navigate("/");
                    }
                } else {
                    alert("点検記録一覧情報の取得に失敗しました。");
                }
                setProcessing_search(false);
            });
        setTimeout(() => {
            setProcessing_search(false);
        }, 10000);
    };
    const createSearchUrl = (data) => {
        const baseUrl = 'api/inspection/inspections?kojiCD=' + data.kojiCD + '&customerCD=' + data.customerCD + '&shitenCD=' + data.shitenCD + '&reportType=' + term;
        const types = term === 0
            ? typeItems.shortTermTypes
            : typeItems.longTermTypes
        const wholeValues = getValues();

        const result = types
            .map(type => {
                const selected = wholeValues[type.id] || [];
                const statuses = selected.map(v => v.status).join(",");
                return `${type.id}=${statuses}`;
            })
            .join("&");

        let returnUrl = baseUrl + '&' + result;
        if (data.thokiYuryoFlg === "included") {
            returnUrl += '&thokiYuryou=1';
        } else if (data.thokiYuryoFlg === "excluded") {
            returnUrl += '&thokiYuryou=0';
        }
        returnUrl += '&customerNameKana=' + data.customerNameKana
        return returnUrl;
    }
    const onSubmit_Reset = () => {
        setProcessing_searchReset(true);
        setValue("customerCD", "", { shouldValidate: true });
        setValue("kojiCD", "", { shouldValidate: true });
        setValue("shitenCD", "", { shouldValidate: true });
        setValue("thokiYuryoFlg", "", { shouldValidate: true });
        setValue("customerNameKana", "", { shouldValidate: true });
        setOrder('asc');
        setOrderBy('');
        setList({});
        if (term === 0) {
            setValue("sts3mt", [])
            setValue("sts6mt", [])
            setValue("sts12mt", [])
            setValue("sts24mt", [])
            sessionStorage.removeItem('shortTermSearchCondition');
        } else {
            setValue("sts4yt", [])
            setValue("sts7yt", [])
            setValue("sts10yt", [])
            sessionStorage.removeItem('longTermSearchCondition');
        }
        setProcessing_searchReset(false);
        //authAxios
        //    .get('api/inspection/inspections?reportType=' + term)
        //    .then(response => {
        //        if (response.status === 200) {
        //            const listdata = JSON.parse((JSON.stringify(response.data)));
        //            setList(listdata);
        //            setPage(0);
        //            setProcessing_searchReset(false)
        //        } else if (response.status === 401) {
        //            alert("認証に失敗しました。");
        //            switch (localStorage.getItem("loginType")) {
        //                case "0":
        //                    navigate("/");
        //                    break
        //                case "1":
        //                    navigate("/omsuser");
        //                    break
        //                case "2":
        //                    navigate("/vender");
        //                    break
        //                default:
        //                    navigate("/");
        //            }
        //            setProcessing_searchReset(false)
        //        }
        //    }).catch((response) => {
        //        alert("絞り込み情報取得に失敗しました。", response.body);
        //        switch (localStorage.getItem("loginType")) {
        //            case "0":
        //                navigate("/");
        //                break
        //            case "1":
        //                navigate("/omsuser");
        //                break
        //            case "2":
        //                navigate("/vender");
        //                break
        //            default:
        //                navigate("/");
        //        }
        //        setProcessing_searchReset(false)
        //    });
        //setTimeout(() => {
        //    setProcessing_searchReset(false);
        //}, 10000);
    }

    const handleAccordion = (_, isExpanded) => {
        setExpanded(isExpanded);
    }

    const onSubmit_none = (kojiCD, kojiName, rptShubetsu, canEdit, canFix, thokiYuryoFlg) => {
        if (deleteMode) { return; }
        if (disable_processing.current === true) { return; }
        if (canEdit !== 1) { return; }

        disable_processing.current = true;
        setProcessing(true);
        authAxios
            .post('api/inspection/detail/' + kojiCD + "/" + rptShubetsu + "?inputType=0", inspecReportList)
            .then(response => {
                if (response.status === 200) {
                    let responseSeqNo = response.data.newSeqNo
                    return authAxios
                        .get('api/inspection/detail/' + kojiCD + "/" + rptShubetsu + '?reportSeqNo=' + responseSeqNo)
                        .then(response => {
                            if (response.status === 200) {
                                navigate("/inspection/" + termName + "/edit", {
                                    state: {
                                        keyData: {
                                            kojiCD: kojiCD,
                                            kojiName: kojiName,
                                            rptShubetsu: rptShubetsu,
                                            rptSeq: responseSeqNo,
                                            inputType: 0,
                                            canEdit: canEdit === 1 ? true : false,
                                            canFix: canFix === 1 ? true : false,
                                            thokiYuryoFlg: thokiYuryoFlg
                                        },
                                    }
                                });
                                disable_processing.current = false
                            }
                        }).catch((response) => {
                            alert("作成中データの取得に失敗しました。", response.body);
                            setProcessing(false);
                            disable_processing.current = false
                        })
                }
            }).catch((response) => {
                alert("点検記録の作成に失敗しました。", response.body);
                setProcessing(false);
                disable_processing.current = false
            })
    }

    const onSubmit_being = (kojiCD, kojiName, rptShubetsu, rptSeq, canEdit, canFix, thokiYuryoFlg) => {
        if (deleteMode) {
            deleteChecked(kojiCD, rptShubetsu, rptSeq);
        } else {
            if (canEdit !== 1) { return; }
            if (processing === true) { return; }
            setProcessing(true);
            authAxios
                .get('api/inspection/detail/' + kojiCD + "/" + rptShubetsu + '?reportSeqNo=' + rptSeq)
                .then(response => {
                    if (response.status === 200) {
                        navigate("/inspection/" + termName + "/edit", {
                            state: {
                                keyData: {
                                    kojiCD: kojiCD,
                                    kojiName: kojiName,
                                    rptShubetsu: rptShubetsu,
                                    rptSeq: rptSeq,
                                    inputType: 1,
                                    canEdit: canEdit === 1 ? true : false,
                                    canFix: canFix === 1 ? true : false,
                                    thokiYuryoFlg: thokiYuryoFlg
                                },
                            }
                        });
                    }
                    setProcessing(false);
                }).catch((response) => {
                    alert("作成中データの取得に失敗しました。", response.body);
                    setProcessing(false);
                })
        }
    }

    const onSubmit_done = (kojiCD, kojiName, rptShubetsu, rptSeq, status, canEdit, canFix, thokiYuryoFlg) => {
        if (deleteMode) {
            deleteChecked(kojiCD, rptShubetsu, rptSeq);
        } else {
            if (processing === true) { return; }
            setProcessing(true);

            authAxios
                .get('api/inspection/detail/' + kojiCD + "/" + rptShubetsu + '?reportSeqNo=' + rptSeq)
                .then(response => {
                    if (response.status === 200) {
                        navigate("/inspection/" + termName + "/" + termName, {
                            state: {
                                keyData: {
                                    kojiCD: kojiCD,
                                    kojiName: kojiName,
                                    rptShubetsu: rptShubetsu,
                                    rptSeq: rptSeq,
                                    status: status,
                                    inputType: 2,
                                    canEdit: canEdit === 1 ? true : false,
                                    canFix: canFix === 1 ? true : false,
                                    thokiYuryoFlg: thokiYuryoFlg
                                },
                            }
                        });
                    }
                }).catch((response) => {
                    alert("作成中データの取得に失敗しました。", response.body);
                    setProcessing(false);
                })
        }
    }

    const cancelClick = () => {
        setDelDialog(false);
    }

    const deleteClick = () => {
        setProcessing(true);
        authAxios.delete('api/inspection/' + kojiCD + '/' + rptShubetsu + '/' + rptSeq + '/delete')
            .then(response => {
                if (response.status === 200) {
                    authAxios
                        .get('api/inspection/inspections?kojiCD=' + getValues("kojiCD") + '&customerCD=' + getValues("customerCD") + '&shitenCD=' + getValues("shitenCD") + '&reportType=' + term)
                        .then(response => {
                            if (response.status === 200) {
                                const listdata = JSON.parse((JSON.stringify(response.data)));
                                setList(listdata);
                                setPage(0);
                                setProcessing(false);
                                setDelDialog(false);
                            } else if (response.status === 401) {
                                alert("認証に失敗しました。");
                                setProcessing(false);
                                setDelDialog(false);
                                switch (localStorage.getItem("loginType")) {
                                    case "0":
                                        navigate("/");
                                        break
                                    case "1":
                                        navigate("/omsuser");
                                        break
                                    case "2":
                                        navigate("/vender");
                                        break
                                    default:
                                        navigate("/");
                                }
                            }
                        }).catch((response) => {
                            alert("一覧情報取得に失敗しました。", response.body);
                            setProcessing(false);
                            setDelDialog(false);
                            switch (localStorage.getItem("loginType")) {
                                case "0":
                                    navigate("/");
                                    break
                                case "1":
                                    navigate("/omsuser");
                                    break
                                case "2":
                                    navigate("/vender");
                                    break
                                default:
                                    navigate("/");
                            }
                        });
                }
            }).catch((response) => {
                alert("作成済み点検記録の削除に失敗しました。", response.body);
                setProcessing(false);
            });
        setTimeout(() => {
            setProcessing(false);
        }, 10000);
    }

    const renderTenkenCell = (tenken, row) => {
        let switcher = null;
        let renderDate = null;
        let seqNo = null;
        switch (tenken) {
            case "3MT":
                switcher = row.tenken3m;
                renderDate = row.tenken3mFinishDate;
                seqNo = row.tenken3mSeqNo;
                break;
            case "6MT":
                switcher = row.tenken6m;
                renderDate = row.tenken6mFinishDate;
                seqNo = row.tenken6mSeqNo;
                break;
            case "12MT":
                switcher = row.tenken12m;
                renderDate = row.tenken12mFinishDate;
                seqNo = row.tenken12mSeqNo;
                break;
            case "24MT":
                switcher = row.tenken24m;
                renderDate = row.tenken24mFinishDate;
                seqNo = row.tenken24mSeqNo;
                break;
            case "4YT":
                switcher = row.tenken4y;
                renderDate = row.tenken4yFinishDate;
                seqNo = row.tenken4ySeqNo;
                break;
            case "7YT":
                switcher = row.tenken7y;
                renderDate = row.tenken7yFinishDate;
                seqNo = row.tenken7ySeqNo;
                break;
            case "10YT":
                switcher = row.tenken10y;
                renderDate = row.tenken10yFinishDate;
                seqNo = row.tenken10ySeqNo;
                break;
            default:
        }
        switch (switcher) {
            case 0:
                return (
                    <CLTableCell align="center" sx={{ pr: 2 }} onClick={() => onSubmit_none(row.kojiCD, row.kojiName, tenken, row.canEdit, row.canFix, row.thokiYuryoFlg)}>
                        <Works disabled={processing} fullWidth>
                            <Grid container
                                justifyContent="space-around"
                                alignItems="center"
                            >
                                <Grid item xs={10}>
                                    <Typography>未作成</Typography>
                                </Grid>
                                <Grid
                                    item xs={2}
                                    container
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    {deleteMode ?
                                        null
                                        :
                                        row.canEdit === 1 ?
                                            <BorderColorSharpIcon color="disabled" sx={{ mb: 1 }} />
                                            :
                                            <VisibilityIcon color="disabled" />
                                    }
                                </Grid>
                            </Grid>
                        </Works>
                    </CLTableCell>
                );
            case 1:
                return (
                    <CLTableCell align="center" sx={{ pr: 2 }} onClick={() => onSubmit_being(row.kojiCD, row.kojiName, tenken, seqNo, row.canEdit, row.canFix, row.thokiYuryoFlg)} >
                        <Works disabled={processing} fullWidth>
                            <Grid container
                                justifyContent="space-around"
                                alignItems="center"
                            >
                                <Grid item xs={10}>
                                    <Typography>作成中</Typography>
                                </Grid>
                                <Grid
                                    item xs={2}
                                    container
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    {deleteMode ?
                                        <DeleteForeverIcon />
                                        :
                                        row.canEdit === 1 ?
                                            <BorderColorSharpIcon color="primary" sx={{ mb: 1 }} />
                                            :
                                            <VisibilityIcon color="disabled" />
                                    }
                                </Grid>
                            </Grid>
                        </Works>
                    </CLTableCell>
                )
            case 2:
                return (
                    <CLTableCell align="center" sx={{ pr: 2 }} onClick={() => onSubmit_done(row.kojiCD, row.kojiName, tenken, seqNo, switcher, row.canEdit, row.canFix, row.thokiYuryoFlg)} >
                        <Works disabled={processing} sx={{ pl: 1.5, color: "#d32f2f" }} fullWidth>
                            <Grid container
                                justifyContent="space-around"
                                alignItems="center"
                            >
                                <Grid item xs={10}>
                                    <Typography>作成済み<br />
                                        {renderDate}
                                    </Typography>
                                </Grid>
                                <Grid
                                    item xs={2}
                                    container
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    {deleteMode ?
                                        <DeleteForeverIcon />
                                        :
                                        row.canEdit === 1 ?
                                            <FileDownloadIcon />
                                            :
                                            <VisibilityIcon />
                                    }
                                </Grid>
                            </Grid>
                        </Works>
                    </CLTableCell>
                );
            case 3:
                return (
                    <CLTableCell align="center" sx={{ pr: 2 }} onClick={() => onSubmit_done(row.kojiCD, row.kojiName, tenken, seqNo, switcher, row.canEdit, row.canFix, row.thokiYuryoFlg)} >
                        <Works disabled={processing} sx={{ pl: 1.5 }} fullWidth>
                            <Grid container
                                justifyContent="space-around"
                                alignItems="center"
                            >
                                <Grid item xs={10}>
                                    <Typography>
                                        作成済み<br />
                                        {renderDate}
                                    </Typography>
                                </Grid>
                                <Grid
                                    item xs={2}
                                    container
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    {deleteMode ?
                                        <DeleteForeverIcon />
                                        :
                                        row.canEdit === 1 ?
                                            <FileDownloadIcon />
                                            :
                                            <VisibilityIcon />
                                    }
                                </Grid>
                            </Grid>
                        </Works>
                    </CLTableCell>
                );
            case 4:
                return (
                    <CLTableCell align="center" sx={{ pr: 2 }} onClick={() => onSubmit_done(row.kojiCD, row.kojiName, tenken, seqNo, switcher, row.canEdit, row.canFix, row.thokiYuryoFlg)} >
                        <Works disabled={processing} sx={{ pl: 1.5 }} fullWidth>
                            <Grid container
                                justifyContent="space-around"
                                alignItems="center"
                            >
                                <Grid item xs={10}>
                                    <Typography>
                                        作成済み<br />(確定)<br />
                                        {renderDate}
                                    </Typography>
                                </Grid>
                                <Grid
                                    item xs={2}
                                    container
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    {deleteMode ?
                                        <DeleteForeverIcon />
                                        :
                                        row.canEdit === 1 ?
                                            <FileDownloadIcon />
                                            :
                                            <VisibilityIcon />
                                    }
                                </Grid>
                            </Grid>
                        </Works>
                    </CLTableCell>
                );
            default:
                return null;
        }
    }
    return (
        <InspectionContents style={{ marginLeft: 0, marginRight: 0 }} maxWidth="xl">
            <InspectionBreadcrumbs />
            <InspectionCommonDialog open={dialogState?.open} dialogState={dialogState} setDialogState={setDialogState} />
            <Grid container spacing={2}>
                <Grid item xs={10} >
                    <Typography variant='h5' sx={{ mb: 1 }}>
                        条件を指定して検索ボタンを押してください。何も条件を指定しないと全件検索になります。
                    </Typography>
                </Grid>
                <Grid container item xs={2}
                    sx={{
                        justifyContent: "flex-end",
                    }}>
                    {deleteAuth ?
                        <Stack sx={{ width: '100%' }}>
                            {deleteMode === true ?
                                <NomalButton fullWidth
                                    type="button"
                                    onClick={() => onSubmit_ChangeListMode()}

                                > <ListIcon sx={{ mr: 1 }} />一覧モード
                                </NomalButton>
                                :
                                <GrayButton fullWidth
                                    type="button"
                                    onClick={() => onSubmit_ChangeDeleteMode()}

                                > <DeleteIcon color="disabled" sx={{ mr: 1 }} />削除モード
                                </GrayButton>
                            }
                        </Stack>
                        :
                        null
                    }
                </Grid>
            </Grid>
            <LoadingDialog load={processing || processing_searchReset || processing_search} />
            <form onSubmit={handleSubmit(onSubmit, onError)}>
                <InspectionDelConfirm
                    kojiCD={kojiCD}
                    rptShubetsu={rptShubetsuName}
                    open={delDialog}
                    cancelClick={cancelClick}
                    deleteClick={deleteClick} />
                <Grid container spacing={2}>
                    <Grid container item rowSpacing={2} xs={10} >
                        <Grid container item xs={12}>
                            <Grid item sx={{ mt: 1 }}>
                                <SearchIcon />
                                <Controller
                                    control={control}
                                    name="customerCD"
                                    rules={validationRules.customerCD}
                                    render={({ field, fieldState }) => (
                                        <TextField
                                            {...field}
                                            id="customerCD"
                                            label="お客様No"
                                            variant="standard"
                                            error={fieldState.invalid}
                                            helperText={fieldState.error?.message}
                                            inputProps={{ maxLength: 7 }}
                                            sx={{
                                                width: 90,
                                                "& .MuiFormHelperText-root": {
                                                    fontSize: "16px"
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item sx={{ mt: 1 }}>
                                <SearchIcon />
                                <Controller
                                    control={control}
                                    name="kojiCD"
                                    rules={validationRules.kojiCD}
                                    render={({ field, fieldState }) => (
                                        <TextField
                                            {...field}
                                            id="kojiCD"
                                            label="工事コード"
                                            variant="standard"
                                            error={fieldState.invalid}
                                            helperText={fieldState.error?.message}
                                            inputProps={{ maxLength: 5 }}
                                            sx={{
                                                width: 80,
                                                "& .MuiFormHelperText-root": {
                                                    fontSize: "16px"
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item sx={{ mt: 1 }}>
                                <SearchIcon />
                                <Controller
                                    control={control}
                                    name="shitenCD"
                                    render={({ field, fieldState }) => (
                                        <FormControl error={fieldState.invalid} >
                                            <InputLabel id="area-label">支店</InputLabel>
                                            <Select
                                                labelId="shiten-label"
                                                label="支店"
                                                variant="standard"
                                                sx={{ width: 150, }}
                                                {...field}
                                            >
                                                {shitenSelectList.map((row, index) => {
                                                    return (
                                                        <MenuItem key={index} value={row.shitenCD}>{row.shitenName}</MenuItem>
                                                    );
                                                })}
                                            </Select>
                                            <FormHelperText>{fieldState.error?.message}</FormHelperText>
                                        </FormControl>
                                    )}
                                />
                            </Grid>
                            <Grid item sx={{ mt: 1 }}>
                                <SearchIcon />
                                <Controller
                                    control={control}
                                    name="thokiYuryoFlg"
                                    render={({ field, fieldState }) => (
                                        <FormControl error={fieldState.invalid} >
                                            <InputLabel id="area-label">長期優良住宅</InputLabel>
                                            <Select
                                                labelId="longterm-label"
                                                label="長期優良住宅"
                                                variant="standard"
                                                sx={{
                                                    width: 150,
                                                }}
                                                {...field}
                                            >
                                                <MenuItem key={0} value={''}>指定なし</MenuItem>
                                                <MenuItem key={1} value={'included'}>限定</MenuItem>
                                                <MenuItem key={2} value={'excluded'}>除外</MenuItem>
                                            </Select>
                                            <FormHelperText>{fieldState.error?.message}</FormHelperText>
                                        </FormControl>
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <Grid container item xs={8} >
                            <SearchIcon />
                            <Grid item xs>
                                <Controller
                                    control={control}
                                    name="customerNameKana"
                                    rules={validationRules.customerNameKana}
                                    render={({ field, fieldState }) => (
                                        <TextField
                                            {...field}
                                            id="customerNameKana"
                                            label="邸名（半角カナ）"
                                            variant="standard"
                                            fullWidth
                                            inputProps={{ maxLength: 40 }}
                                            error={fieldState.invalid}
                                            helperText={fieldState.error?.message}
                                            sx={{
                                                "& .MuiFormHelperText-root": {
                                                    fontSize: "16px"
                                                }
                                            }}
                                            onBlur={(e) => {
                                                let converted = toHalfWidthKana(e.target.value);
                                                converted = toHalfWidthAlpha(converted);
                                                converted = toHalfWidthNumber(converted);
                                                if (converted !== e.target.value) {
                                                    field.onChange(converted);
                                                }
                                                field.onBlur();
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    let converted = toHalfWidthKana(e.target.value);
                                                    converted = toHalfWidthAlpha(converted);
                                                    converted = toHalfWidthNumber(converted);

                                                    if (converted !== e.target.value) {
                                                        field.onChange(converted);
                                                    }
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Accordion
                                elevation={0}
                                disableGutters
                                sx={{
                                    width: '100%',
                                    maxWidth: '100%',
                                    backgroundColor: alpha("#289bdf", 0.05),
                                    boxShadow: 'none',
                                    '&:before': { display: 'none' },
                                    '&.Mui-expanded': {
                                        margin: 0,
                                    },
                                    transition: 'background-color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: alpha("#289bdf", 0.2),
                                    },
                                }}
                                expanded={expanded}
                                onChange={handleAccordion}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >{expanded ?
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        <DoneAllIcon fontSize='large' />
                                        <Typography component="span" variant='h5'>いずれかで検索
                                        </Typography>
                                    </Stack>
                                    :
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        <AddCircleOutlineIcon fontSize='large' />
                                        <Typography component="span" variant='h5'>追加条件
                                        </Typography>
                                    </Stack>
                                    }

                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={2}>
                                        <Grid item
                                            sx={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: 2,
                                            }}
                                        >
                                            {(term === 0 ? typeItems.shortTermTypes : typeItems.longTermTypes)
                                                .map((type) => {
                                                    const typeValue = watch(type.id);
                                                    return (
                                                        <Box key={type.id} sx={{ width: 240 }}>
                                                            <Controller
                                                                name={type.id}
                                                                control={control}
                                                                defaultValue={[]}
                                                                render={({ field }) => (
                                                                    <Autocomplete
                                                                        multiple
                                                                        disableCloseOnSelect
                                                                        options={statusItems}
                                                                        getOptionLabel={(option) => option.label}
                                                                        value={typeValue || []}
                                                                        sx={{
                                                                            "& .MuiAutocomplete-inputRoot": {
                                                                                position: "relative",
                                                                            },
                                                                            "& .MuiAutocomplete-input": {
                                                                                position: "absolute",
                                                                                width: "1px",
                                                                                minWidth: "1px",
                                                                                padding: 0,
                                                                                margin: 0,
                                                                            }
                                                                        }}
                                                                        onChange={(_, newValue) => {
                                                                            field.onChange(newValue);
                                                                        }}
                                                                        isOptionEqualToValue={(option, value) => option.status === value.status}
                                                                        renderOption={(props, option) => (
                                                                            <li {...props} key={option.status}>
                                                                                <Typography style={{ color: option.labelColor || "inherit" }}>
                                                                                    {option.label}
                                                                                </Typography>
                                                                            </li>
                                                                        )}
                                                                        renderTags={(tagValue, getTagProps) =>
                                                                            tagValue.map((option, index) => (
                                                                                <Chip
                                                                                    key={option.status}
                                                                                    label={option.label}
                                                                                    sx={{
                                                                                        "& .MuiAutocomplete-tag": {
                                                                                            maxWidth: "none",
                                                                                        },
                                                                                        "& .MuiAutocomplete-input": {
                                                                                            flexGrow: 0,
                                                                                            width: 0,
                                                                                            minWidth: 0,
                                                                                        }
                                                                                    }}
                                                                                    {...getTagProps({ index })}
                                                                                    style={{ color: option.labelColor || "inherit" }}
                                                                                />
                                                                            ))
                                                                        }
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                label={type.label}
                                                                                variant="outlined"
                                                                                sx={{
                                                                                    "& .MuiOutlinedInput-root": {
                                                                                        backgroundColor: "#FFFFFF",
                                                                                        minHeight: "55px",
                                                                                    },
                                                                                }}
                                                                                inputProps={{
                                                                                    ...params.inputProps,
                                                                                    readOnly: true,     // 入力を禁止（キーボード入力できない）
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                )}
                                                            />
                                                        </Box>)
                                                })}
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>
                    <Grid container item xs={2} display="flex" justifyContent="center" alignItems="center">
                        <Stack spacing={1} sx={{ width: '100%' }}>
                            <NomalButton
                                fullWidth
                                className="confButton"
                                type="submit"
                                value="search"
                                disabled={processing_search}
                            ><SearchIcon sx={{ mr: 1 }} />
                                {processing_search ? "検索中" : "検索"}
                            </NomalButton>
                            <CautionButton
                                fullWidth
                                type="button"
                                disabled={processing_searchReset}
                                onClick={() => onSubmit_Reset()}
                            ><RefreshIcon sx={{ mr: 1 }} />
                                {processing_searchReset ? "リセット中" : "検索条件リセット"}
                            </CautionButton>
                        </Stack>
                    </Grid>
                </Grid>
            </form>
            <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                sx={{ mt: 1, mr: 5 }}
            >
                <HomeWorkIcon color="success" />
                <Typography variant='h7' color="text.secondary">
                    ：長期優良住宅
                </Typography>
            </Box>
            <TableFlame sx={{ mt: 1 }}>
                <Table
                    align="center"
                >
                    <EnhancedTableHead
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        rowCount={list?.length}
                        mode={deleteMode}
                    />
                    <TableBody>
                        {term === 0 ?
                            stableSort(list?.inspectionShortList, getComparator(order, orderBy))
                                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                ?.map((row, index) => {
                                    return (
                                        <TableRow
                                            key={index}
                                            hover
                                            tabIndex={-1}>
                                            <TableCell align="left" sx={{ pr: 0 }}>{row.customerCD}</TableCell>
                                            <TableCell align="left" sx={{ pr: 0 }}>{row.kojiCD}</TableCell>
                                            <TableCell align="left" sx={{ pr: 0 }}>{row.shitenName}</TableCell>
                                            <TableCell align="left" sx={{ pr: 0 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                                    {row.thokiYuryoFlg === 1 ?
                                                        <HomeWorkIcon color="success" />
                                                        :
                                                        <Box sx={{ width: 24, height: 24 }} />}
                                                    {row.kojiName}
                                                </Box>
                                            </TableCell>
                                            {renderTenkenCell("3MT", row)}
                                            {renderTenkenCell("6MT", row)}
                                            {renderTenkenCell("12MT", row)}
                                            {renderTenkenCell("24MT", row)}
                                        </TableRow>
                                    )
                                })
                            : term === 1 ?
                                //ToDo長期保証
                                stableSort(list?.inspectionLongList, getComparator(order, orderBy))
                                    ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    ?.map((row, index) => {
                                        return (
                                            <TableRow
                                                key={index}
                                                hover
                                                tabIndex={-1}>
                                                <TableCell align="left" sx={{ pr: 0 }}>{row.customerCD}</TableCell>
                                                <TableCell align="left" sx={{ pr: 0 }}>{row.kojiCD}</TableCell>
                                                <TableCell align="left" sx={{ pr: 0 }}>{row.shitenName}</TableCell>
                                                <TableCell align="left" sx={{ pr: 0 }}>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                                        {row.thokiYuryoFlg === 1 ?
                                                            <HomeWorkIcon color="success" />
                                                            :
                                                            <Box sx={{ width: 24, height: 24 }} />}
                                                        {row.kojiName}
                                                    </Box>
                                                </TableCell>
                                                {renderTenkenCell("4YT", row)}
                                                {renderTenkenCell("7YT", row)}
                                                {renderTenkenCell("10YT", row)}
                                            </TableRow>
                                        )
                                    })
                                : null}
                    </TableBody>
                </Table>
            </TableFlame>
            {list &&
                Object.keys(list).length !== 0 &&
                (list?.inspectionLongList?.length !== 0 || list?.inspectionShortList?.length !== 0) ?
                <TablePagination
                    component="div"
                    count={term === 0 ?
                        list?.inspectionShortList?.length :
                        term === 1 ?
                            list?.inspectionLongList?.length : 0}
                    labelRowsPerPage="表示件数"
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 30, 50]}
                    page={page}
                    labelDisplayedRows={(from, to,
                        count = term === 0 ?
                            list?.inspectionShortList?.length :
                            term === 1 ?
                                list?.inspectionLongList?.length : 0) => (`全${count}件中　${from.from}件～${from.to === -1 ? from.count : from.to}件を表示  `)}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                : <Grid />
            }
        </InspectionContents >
    );
}